var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSponsorBooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.71875 3.75H11.7812C12.1777 3.75 12.5 3.42773 12.5 3.03125C12.5 2.88867 12.457 2.75 12.3789 2.63281L10.9023 0.417969C10.7285 0.15625 10.4375 0 10.123 0H2.37695C2.06445 0 1.77148 0.15625 1.59766 0.417969L0.121094 2.63086C0.0429687 2.75 0 2.88867 0 3.0293C0 3.42773 0.322266 3.75 0.71875 3.75ZM1.25 4.375V9.0625C1.25 9.58008 1.66992 10 2.1875 10H6.5625C7.08008 10 7.5 9.58008 7.5 9.0625V4.375H6.25V7.5H2.5V4.375H1.25ZM10 4.375V9.375C10 9.7207 10.2793 10 10.625 10C10.9707 10 11.25 9.7207 11.25 9.375V4.375H10Z",
    fill: "#E8EAED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorBooth);
export default __webpack_public_path__ + "static/media/sponsor-booth.a0ba19512859bddd065f94bcb2dd6ff7.svg";
export { ForwardRef as ReactComponent };